

const imageOutputStyle = {
    imageStyle: {
      maxWidth: '100%',
    },
    figureStyle: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '20px 0',
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      backgroundColor: 'aliceblue',
      border: '1px solid #eee'
    },
    figcaptionStyle: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      padding: '5px 10px',
      fontSize: '12px',
      backgroundColor: '#2d333a',
      color: 'white',
      borderRadius: '2px',
      cursor: 'default',
    }
  };
  
  export default imageOutputStyle;